import 'css-chunksrc/client/scenes/listCreation/listCreationForm/styles.scss';export default {
  "listCreationForm": "_listCreationForm_e4s7e_1",
  "group": "_group_e4s7e_5",
  "title": "_title_e4s7e_9",
  "dateGroup": "_dateGroup_e4s7e_14",
  "listSelect": "_listSelect_e4s7e_23",
  "dateTimeInput": "_dateTimeInput_e4s7e_27",
  "row": "_row_e4s7e_32",
  "textArea": "_textArea_e4s7e_41"
};